/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MinusIcon20Light = forwardRef('MinusIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M1.917 9.5a.5.5 0 0 1 .5-.5h14.166a.5.5 0 1 1 0 1H2.417a.5.5 0 0 1-.5-.5Z" })));
});
